import React from 'react';
import { Calendar, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function TeamUpcomingLeavesWidget() {
  const navigate = useNavigate();
  // Mock data - Congés de l'équipe
  const teamUpcomingLeaves = [{
    id: 1,
    employee: 'Marie Dupont',
    type: 'Congés payés',
    startDate: '22 déc. 2023',
    endDate: '31 déc. 2023',
    days: 6,
    status: 'approved'
  }, {
    id: 2,
    employee: 'Jean Martin',
    type: 'RTT',
    startDate: '18 déc. 2023',
    endDate: '18 déc. 2023',
    days: 1,
    status: 'approved'
  }, {
    id: 3,
    employee: 'Thomas Petit',
    type: 'Congés payés',
    startDate: '27 déc. 2023',
    endDate: '29 déc. 2023',
    days: 3,
    status: 'pending'
  }];
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-2157">
      <div className="flex items-center justify-between mb-4" data-id="element-2158">
        <h3 className="font-semibold text-gray-900" data-id="element-2159">Congés de l'équipe</h3>
        <Calendar className="h-5 w-5 text-blue-600" data-id="element-2160" />
      </div>
      {teamUpcomingLeaves.length > 0 ? <div className="space-y-3 flex-1" data-id="element-2161">
          {teamUpcomingLeaves.map(leave => <div key={leave.id} className={`border-l-4 ${leave.status === 'approved' ? 'border-green-500' : 'border-yellow-500'} pl-3 py-2`} data-id="element-2162">
              <div className="flex items-center gap-2 mb-1" data-id="element-2163">
                <User className="h-4 w-4 text-gray-500" data-id="element-2164" />
                <p className="font-medium text-gray-900 text-sm" data-id="element-2165">
                  {leave.employee}
                </p>
              </div>
              <p className="text-sm text-gray-700" data-id="element-2166">{leave.type}</p>
              <p className="text-sm text-gray-600" data-id="element-2167">
                {leave.startDate} - {leave.endDate}
              </p>
              <div className="flex items-center justify-between mt-1" data-id="element-2168">
                <p className="text-xs text-gray-500" data-id="element-2169">
                  {leave.days} jour{leave.days > 1 ? 's' : ''}
                </p>
                <span className={`text-xs px-2 py-0.5 rounded-full ${leave.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2170">
                  {leave.status === 'approved' ? 'Approuvé' : 'En attente'}
                </span>
              </div>
            </div>)}
        </div> : <div className="text-center py-4 flex-1 flex items-center justify-center" data-id="element-2171">
          <p className="text-gray-500" data-id="element-2172">Aucun congé prévu</p>
        </div>}
      <button onClick={() => navigate('/manager/approbations')} className="mt-4 w-full py-2 px-4 border border-gray-300 hover:bg-gray-50 rounded-md text-sm font-medium text-gray-700 transition-colors duration-150 ease-in-out" data-id="element-2173">
        Gérer les congés
      </button>
    </div>;
}